import {
  AccountTypes,
  IndividualDesignationListedTypes,
  IRADesignationListedTypes,
  IRATrustTypes,
} from '@interfaces/models';

export enum ChecklistContentType {
  TEXT = 'TEXT',
  LINK = 'LINK',
  LIST = 'LIST',
  LIST_ITEM_TEXT = 'LIST_ITEM_TEXT',
  LIST_ITEM_TOOLTIP = 'LIST_ITEM_TOOLTIP',
  BANNER_TEXT = 'BANNER_TEXT',
  SPECIAL = 'SPECIAL',
}

export enum ChecklistAccountType {
  ALL = 'ALL',
  IRA = 'IRA',
  IRA_NAME_OR_RELATIONSHIP = 'IRA_NAME_OR_RELATIONSHIP',
  IRA_NAME = 'IRA_NAME',
  IRA_NAME_MARRIED = 'IRA_NAME_MARRIED',
  IRA_NAME_NOT_MARRIED = 'IRA_NAME_NOT_MARRIED',
  IRA_RELATIONSHIP = 'IRA_RELATIONSHIP',
  IRA_RELATIONSHIP_MARRIED = 'IRA_RELATIONSHIP_MARRIED',
  IRA_RELATIONSHIP_NOT_MARRIED = 'IRA_RELATIONSHIP_NOT_MARRIED',
  IRA_EXECUTOR = 'IRA_EXECUTOR',
  IRA_TRUSTEE = 'IRA_TRUSTEE',
  IRA_TRUSTEE_AGREEMENT = 'IRA_TRUSTEE_AGREEMENT',
  IRA_TRUSTEE_WILL = 'IRA_TRUSTEE_WILL',
  INDV_OR_JOINT = 'INDV_OR_JOINT',
  INDV = 'INDV',
  INDV_BENEFICIARY = 'INDV_BENEFICIARY',
  INDV_EXECUTOR = 'INDV_EXECUTOR',
  JOINT = 'JOINT',
  JOINT_MARRIED = 'JOINT_MARRIED',
  JOINT_NOT_MARRIED = 'JOINT_NOT_MARRIED',
  EXECUTOR = 'EXECUTOR',
  UNKNOWN = 'UNKNOWN',
}

export interface ChecklistForm {
  accountTypeInheriting: AccountTypes;
  IRADesignation?: IRADesignationListedTypes;
  individualDesignation?: IndividualDesignationListedTypes;
  isSpouse?: 'YES' | 'NO';
  typeOfTrust?: IRATrustTypes;
}
